import { ExpertAvailabilityEnum as DtoAvailabilityEnum } from 'types/api.types.generated.d';

export enum AvailabilityEnum {
  Immediately = 'Immediately',
  TwoWeeks = 'TwoWeeks',
  Month = 'Month',
  ThreeMonths = 'ThreeMonths',
}

export const mapDtoToAvailabilityEnum = (
  unit: DtoAvailabilityEnum | null,
  noticeLength: number | null,
): AvailabilityEnum | null => {
  if (!unit || noticeLength == null) {
    return null;
  }

  if (unit === DtoAvailabilityEnum.Immediately) {
    return AvailabilityEnum.Immediately;
  }

  if (unit === DtoAvailabilityEnum.Days) {
    return noticeLength <= 14 ? AvailabilityEnum.TwoWeeks : AvailabilityEnum.Month;
  }

  if (unit === DtoAvailabilityEnum.Months) {
    return noticeLength <= 1 ? AvailabilityEnum.Month : AvailabilityEnum.ThreeMonths;
  }

  return null;
};

export const mapAvailabilityToDtoEnum = (
  availability: AvailabilityEnum,
): { unit: DtoAvailabilityEnum; noticeLength: number } => {
  switch (availability) {
    case AvailabilityEnum.Immediately:
      return { unit: DtoAvailabilityEnum.Immediately, noticeLength: 0 };
    case AvailabilityEnum.TwoWeeks:
      return { unit: DtoAvailabilityEnum.Days, noticeLength: 14 };
    case AvailabilityEnum.Month:
      return { unit: DtoAvailabilityEnum.Months, noticeLength: 1 };
    case AvailabilityEnum.ThreeMonths:
      return { unit: DtoAvailabilityEnum.Months, noticeLength: 3 };
    default:
      throw new Error('Unknown Availability value');
  }
};
